module.exports = __webpack_public_path__ + "static/media/article-1.6ea6e9ee.png";